<template>
  <div class="usermodel">
    <el-popover placement="bottom" trigger="click" popper-class="user-div">
      <div class="userinfo">
        <div class="user-right">
          <span class="name">{{user.name}}</span>
          <span class="job">{{user.MainPositionName}}</span>
        </div>
      </div>
      <div v-if="perList.includes('17-1') || user.account === 'admin'" class="setting">
        <span @click="go"><i class="iconfont iconicon_set_up"></i>{{$t("sys.sysSet")}}</span>
        <span @click="personSkyDrive"><i class="iconfont iconicon_personal_network_disk"></i>{{$t("sys.perSkyDrive")}}</span>
      </div>
      <div class="setting">
        <span @click="viewUserInfo"><i class="iconfont iconicon_modify_avatar"></i>账户资料</span>
      </div>
      <div class="setting" @click="quit()">
        <span><i class="iconfont iconicon_special_effects_drop_out"></i>{{$t("sys.exit")}}</span>
      </div>
      <div slot="reference" class="userhead">
        <img :src="user.headImg" />
      </div>
    </el-popover>
  </div>
</template>
<script>
import ApiService from '@/services/API-services'
import {mapMutations} from 'vuex'
import Cropper from 'cropperjs'
export default {
  name: 'userdiv',
  components: {},
  data() {
    return {
      user: {},
      token: '',
      userHead: '',
      perList: '',
      userId: ''
    }
  },
  created() {
    // this.getAuth()
    // this.perList = this.$store.state.perList
    this.user = JSON.parse(localStorage.user)
    this.userId = JSON.parse(localStorage.user).userId
  },
  mounted() {
    if (localStorage.user) {
      this.user = JSON.parse(localStorage.user)
    }
  },
  computed: {
    head() {
      return this.$store.state.userHead
    }
  },
  watch: {
    head() {
      this.user.headImg = this.$store.state.userHead
    }
  },
  methods: {
    ...mapMutations(['showModal']),
    getAuth() {
      ApiService.user
        .getAuth({
          userId: JSON.parse(localStorage.user).userId
        })
        .then(res => {
          let a = JSON.parse(res.data[0].permissionJson)
          let arr1 = []
          for (let i = 0; i < a.length; i++) {
            arr1.push(a[i].code)
            for (let k = 0; k < a[i].child.length; k++) {
              arr1.push(a[i].child[k].code)
            }
          }
          this.$store.commit('setPerList', arr1)
          this.perList = arr1
        })
    },
    personSkyDrive() {
      this.showModal({
        name: 'SkyDrive',
        show: true,
        top: '20vh',
        left: '10vw',
        zindex: '100'
      })
    },
    viewUserInfo() {
      this.showModal({
        name: 'userInfo',
        show: true,
        top: '2rem',
        left: '40%',
        data: ''
      })
    },
    changeHead() {
      this.showModal({
        name: 'changeHead',
        show: true,
        top: '2rem',
        left: '40%',
        data: ''
      })
    },
    go() {
      window.open(
        window.R_config.spc_admin +
          '?t=' +
          this.$store.state.userInfo.name +
          '&m=' +
          this.$store.state.userInfo.pwd +
          '&k=' +
          sessionStorage.octopus_token
      )
    },
    warnMsg() {
      this.$store.commit('showModal', {
        name: 'warnMsg',
        show: true,
        top: '3rem'
      })
    },
    changePwd() {
      this.$store.commit('showModal', {
        name: 'changePwd',
        show: true,
        top: '3rem'
      })
    },
    quit() {
      ApiService.octopus_user.logOut({
        userId: this.user.userId,
        account: this.user.account
      }).then(res => {
        this.$utils.delCookie('spcUser')
        this.$utils.delCookie('spcPwd')
        sessionStorage.removeItem('userName')
        sessionStorage.removeItem('userSign')
        sessionStorage.removeItem('octopus_token')
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        this.$utils.delCookie('token')
        window.location.href = '/'
      })
    },
    chatQuit() {
      ApiService.chat.loginOut({
        username: this.user.account
      })
      .then(res => {
        // console.log(res)
      })
    }
  }
}

</script>
<style lang="scss">
.usermodel {
  border: 1px;
  cursor: pointer;
  background: transparent;
  margin: 0 5px;
  display: flex;
  align-items: center;
}

.user-div {
  // background: #fff;
  padding: 0;
}
.info-alert {
  width: 159px;
  height: 64px;
  background: #fff;
  position: absolute;
}

.userhead {
  width: 30px;
  height: 30px;
  border-radius: 50%;

}

.userhead img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit:cover;
}

.userinfo {
  color: #fff;
  // display: flex;
  // align-content: center;
  // align-items: center;
  padding: 5px 0;
}

.user-left img {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
}
.user-right {
  display: flex;
  flex-flow: column;
  margin-left: 10px;
}
.user-right .name {
  font-size: 0.14rem;
  font-family: MicrosoftYaHei-Bold;
  text-align: left;
  font-weight: bold;
  -webkit-text-size-adjust: none;
  -webkit-transform: scale(0.9);
  transform: scale(0.9);
}

.user-right .job {
  font-size: 0.12rem;
  font-family: MicrosoftYaHei;
  -webkit-text-size-adjust: none;
  -webkit-transform: scale(0.9);
  transform: scale(0.9);
}

.setting {
  span {
    display: flex;
    align-items: center;
    font-size: .1rem;
    font-family: MicrosoftYaHei;
    color: rgba(255, 255, 255, .65);
    cursor: pointer;
    height: 30px;
    line-height: 30px;
    text-align: left;
    padding: 2px 10px;
    &:hover {
      color: #fff;
    }
    i {
      margin-right: 5px;
    }
  }
  border-top: 1px solid rgba(255, 255, 255, .1);
  display: flex;
  flex-direction: column;
}

</style>



// WEBPACK FOOTER //
// src/components/user/userdiv.vue